// extracted by mini-css-extract-plugin
export default {"heading":"YellowHeaderWrapper_heading__aexZt","wrapper":"YellowHeaderWrapper_wrapper__JxAnM","wrapper-without-borders":"YellowHeaderWrapper_wrapper-without-borders__NgqRi"};